/**
 * @generated SignedSource<<27e6aadd9d7076d0ab5c176e2cdc4742>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Export_Piece$data = {
  readonly id: string;
  readonly file: {
    readonly version: string;
    readonly midi_file_download_url: string | null;
    readonly audio_file_download_url: string | null;
  } | null;
  readonly " $fragmentType": "Export_Piece";
};
export type Export_Piece$key = {
  readonly " $data"?: Export_Piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"Export_Piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Export_Piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "midi_file_download_url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "audio_file_download_url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "7ffd9edf2acd25f1bd644b123b3dd94a";

export default node;
